import { render, staticRenderFns } from "./CustomerAutocomplete.vue?vue&type=template&id=33ac5f66&scoped=true&"
import script from "./CustomerAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CustomerAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAutocomplete.vue?vue&type=style&index=0&id=33ac5f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac5f66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ac5f66')) {
      api.createRecord('33ac5f66', component.options)
    } else {
      api.reload('33ac5f66', component.options)
    }
    module.hot.accept("./CustomerAutocomplete.vue?vue&type=template&id=33ac5f66&scoped=true&", function () {
      api.rerender('33ac5f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Autocomplete/CustomerAutocomplete.vue"
export default component.exports